import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateProjectPersonnelBulkCreationMutation({ projectId }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        `/projects/${projectId}/project_personnel/bulk_creations`,
        { bulk_creation: params },
      );

      return response.data;
    },
    onSuccess: () => {
      [
        'assignablePersonnelSearches',
        'companyRoleSearches',
        'projectPersonnel',
        'signatureStatus',
        'teamSearches',
      ].forEach((queryKeySegment) =>
        queryClient.invalidateQueries(['projects', projectId, queryKeySegment]),
      );
    },
  });
}
